import { CircularProgress, Layer, Page } from 'ui/components'

import { Actions, Filter, ManageUserDialog, ResetPassword, UsersTable } from './components'
import { NEW_USER } from './constants'
import { useUsers } from './hooks'

export default () => {
  const { data, isFetching, filter, resetFilter, onSaved, edit, changeStatus, resetPassword, onResetMFA } = useUsers()
  const { onEdit, userToEdit, closeEditDialog } = edit
  const { UserStatusConfirmation, onChangeStatus } = changeStatus
  const { userToResetPassword, closeResetPasswordDialog, onResetPassword } = resetPassword
  const { active, page, size, searchTerm, onSearch, onActiveChange, onPageChange } = filter

  if (isFetching && !page) {
    return <CircularProgress centered />
  }

  // Don't render page until filter contains values returned from API.
  if (!page || !data) {
    return null
  }

  const { activeValues, enableCreate, enableRoleSelector, relationshipsToAssign, roles, users, totalCount } = data

  return (
    <Page title="All Users" actions={<Actions onAddUser={enableCreate ? () => onEdit(NEW_USER) : undefined} />}>
      <UserStatusConfirmation />
      <ResetPassword user={userToResetPassword} onClose={closeResetPasswordDialog} />
      {!!userToEdit && (
        <ManageUserDialog
          enableRoleSelector={enableRoleSelector}
          initialValue={userToEdit}
          onClose={closeEditDialog}
          roles={roles}
          relationshipsToAssign={relationshipsToAssign}
          onSaved={onSaved}
        />
      )}
      <Layer rounded shadowed stretch>
        <Filter
          active={active}
          onActiveChange={onActiveChange}
          activeValues={activeValues}
          onReset={resetFilter}
          searchTerm={searchTerm}
          onSearch={onSearch}
        />
        <UsersTable
          users={users}
          onEdit={onEdit}
          onChangeStatus={onChangeStatus}
          onResetPassword={onResetPassword}
          onResetMFA={onResetMFA}
          onPageChange={onPageChange}
          page={page}
          size={size}
          total={totalCount}
          isFetching={isFetching}
        />
      </Layer>
    </Page>
  )
}
